import _toConsumableArray from "/home/mills/projects/opensourceradio/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { stringify, hyphenateStyleName, isKeyframes } from './utils';
import { settings, config } from './config';
var keys = Object.keys;
var cache = {};
var theme = {};

function createOrUpdateStyledNode(content) {
  var _settings = settings(),
      styleSheetId = _settings.styleSheetId;

  var el = document.getElementById(styleSheetId);

  if (el) {
    el.innerHTML = "".concat(el.innerHTML, "\n").concat(content);
  } else {
    var _el = document.createElement("style");

    _el.setAttribute("id", styleSheetId);

    _el.innerHTML = content;
    document.head.appendChild(_el);
  }
}

function keyframes(className, styles) {
  var base = "@keyframes ".concat(className, " {");
  var timings = keys(styles).map(function (timing) {
    var timingValues = styles[timing];
    var timingStyles = keys(timingValues).map(function (timingStyle) {
      return "".concat(hyphenateStyleName(timingStyle), ": ").concat(timingValues[timingStyle], ";");
    });
    return "".concat(timing, " { ").concat(timingStyles.join(' '), " }");
  });
  return {
    className: className,
    cssRules: ["".concat(base, " ").concat(timings.join(' '), " }")]
  };
}

function generateClass(styles) {
  var _settings2 = settings(),
      hash = _settings2.hash,
      id = _settings2.id,
      classPrefix = _settings2.classPrefix;

  var psuedoStyles = {};
  var hashedStyles = hash(JSON.stringify(styles));

  if (cache[hashedStyles]) {
    return {
      className: cache[hashedStyles]
    };
  }

  var className = "".concat(classPrefix, "-").concat(id());
  cache[hashedStyles] = className;
  var rootKeys = keys(styles);

  if (rootKeys.length == 1 && isKeyframes(rootKeys[0])) {
    return keyframes(className, styles[rootKeys[0]]);
  }

  function parse(obj) {
    var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return keys(obj).reduce(function (acc, k) {
      if (typeof obj[k] === "string") {
        acc.push("".concat(hyphenateStyleName(k), ":"), "".concat(obj[k], ";"));
      } else {
        psuedoStyles["".concat(root).concat(k)] = parse(obj[k], "".concat(root).concat(k));
      }

      return acc;
    }, []);
  }

  var mainStyles = parse(styles);
  var selector = ".".concat(className);
  var cssRules = [stringify(selector, mainStyles)].concat(_toConsumableArray(keys(psuedoStyles).reduce(function (acc, pseudoSelector) {
    var sel = "".concat(selector).concat(pseudoSelector);
    acc.push(stringify(sel, psuedoStyles[pseudoSelector]));
    return acc;
  }, [])));
  return {
    className: className,
    cssRules: cssRules
  };
}
/**
* Adds raw css to the stylesheet
* @tutorial raw
* @param {string} str
* @memberof stylish
*/


function raw(str) {
  str = str.replace(/\s+/g, " ");
  createOrUpdateStyledNode(str);
}
/**
* The main stylish function
* @class
* @tutorial main-usage
* @tutorial advanced-usage
* @tutorial animations
* @tutorial theme
* @param styles {Object|Array|Function} styles
* @returns {String|Array<String>}
*/


function stylish(styles) {
  if (arguments.length === 1) {
    if (typeof styles === 'function') {
      styles = styles(theme);

      if (Array.isArray(styles)) {
        return stylish.apply(void 0, _toConsumableArray(styles));
      }
    }

    var _generateClass = generateClass(styles),
        className = _generateClass.className,
        _cssRules = _generateClass.cssRules;

    if (_cssRules && _cssRules.length > 0) {
      createOrUpdateStyledNode(_cssRules.join('\n'));
    }

    return className;
  }

  var _reduce$call = [].reduce.call(arguments, function (acc, s) {
    var _generateClass2 = generateClass(s),
        className = _generateClass2.className,
        cssRules = _generateClass2.cssRules;

    acc.classNames.push(className);

    if (cssRules) {
      var _acc$cssRules;

      (_acc$cssRules = acc.cssRules).push.apply(_acc$cssRules, _toConsumableArray(cssRules));
    }

    return acc;
  }, {
    classNames: [],
    cssRules: []
  }),
      classNames = _reduce$call.classNames,
      cssRules = _reduce$call.cssRules;

  if (cssRules.length) {
    createOrUpdateStyledNode(cssRules.join('\n'));
  }

  return classNames;
}
/**
* Gets the current cache object
* @tutorial cache
* @returns {Object} cache
* @memberof stylish
*/


var getCache = function getCache() {
  return cache;
};
/**
* Gets the current theme object
* @tutorial theme
* @returns {Object} theme
* @memberof stylish
*/


var getTheme = function getTheme() {
  return theme;
};
/**
* Clears the style object cache
* @tutorial cache
* @memberof stylish
*/


var clearCache = function clearCache() {
  cache = {};
};
/**
* Clears current theme object
* @tutorial theme
* @memberof stylish
*/


var clearTheme = function clearTheme() {
  theme = {};
};
/**
* Creates or overwrites the current theme
* @param {Object} newTheme
* @memberof stylish
*/


var createTheme = function createTheme(newTheme) {
  theme = newTheme;
};

stylish.__proto__.raw = raw;
stylish.__proto__.setConfig = config;
stylish.__proto__.cache = getCache;
stylish.__proto__.theme = getTheme;
stylish.__proto__.createTheme = createTheme;
stylish.__proto__.clearCache = clearCache;
stylish.__proto__.clearTheme = clearTheme;
export default stylish;